import { createSelector } from '@reduxjs/toolkit';
import { selectBathTypeValue } from './selectBathTypeValue';
import { EFacilityType } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Ванна', value: EFacilityType.Bath },
  { label: 'Душевая кабина', value: EFacilityType.Shower },
];

export const selectBathTypeFilter = createSelector(selectBathTypeValue, value => ({
  label: 'Ванна/Душ',
  value,
  options: OPTIONS,
}));
